import React, { useState } from "react";
import { Redirect } from "react-router";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import validator from "validator";
import Logo from "../../assets/images/rearmrobotics-white.png";
import Input from "../../components/DataEntry/Input";
import authService from "../../services/AuthService";

function Register() {
  const [loading, setLoading] = React.useState(false);
  const [redirect, setRedirect] = useState(false);
  const [userData, setUserData] = useState({
    fullname: "",
    email: "",
    password: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    fullname: "",
    email: "",
    password: "",
  });

  const validateFields = () => {
    var formValidated = true;
    var newValidationErrors = {
      fullname: "",
      email: "",
      password: "",
    };

    if (validator.isEmpty(userData.fullname)) {
      newValidationErrors = {
        ...newValidationErrors,
        fullname: "Invalid full name",
      };
      formValidated = false;
    }
    if (
      !validator.isStrongPassword(userData.password, {
        minLength: 8,
        minNumbers: 1,
        returnScore: false,
        minLowercase: 0,
        minUppercase: 0,
        minSymbols: 0,
      })
    ) {
      newValidationErrors = {
        ...newValidationErrors,
        password: "Password too weak",
      };
      formValidated = false;
    }
    if (!validator.isEmail(userData.email)) {
      newValidationErrors = { ...newValidationErrors, email: "Email invalid" };
      formValidated = false;
    }
    setValidationErrors(newValidationErrors);
    return formValidated;
  };

  const submitRegister = async (e) => {
    e.preventDefault();

    if (validateFields()) {
      localStorage.clear();
      setLoading(true);
      try {
        const user = await authService.register(userData);
        if (user) {
          setRedirect(true);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setLoading(false);
      }
      setUserData({ fullname: "", email: "", password: "" });
    }
  };

  const handleChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="register">
      {redirect && <Redirect to="/devices" />}

      <div className="container">
        <img style={{ width: "70%" }} src={Logo} alt="logo" />
        <form>
          <Input
            placeholder="Full name"
            className="input-classic"
            name="fullname"
            onChange={handleChange}
            status={validationErrors.fullname && "error"}
            validationMessage={validationErrors.fullname}
            onPressEnter={submitRegister}
          />
          <Input
            placeholder="Email"
            className="input-classic"
            name="email"
            onChange={handleChange}
            status={validationErrors.email && "error"}
            validationMessage={validationErrors.email}
            onPressEnter={submitRegister}
          />
          <Input
            placeholder="Password"
            className="input-classic"
            type="password"
            name="password"
            onChange={handleChange}
            status={validationErrors?.password && "error"}
            validationMessage={validationErrors.password}
            onPressEnter={submitRegister}
          />
          <button
            className={`button ${loading && "button--loading"}`}
            onClick={submitRegister}
            style={{ margin: "1rem auto 0" }}
          >
            {loading ? "" : "REGISTER"}
          </button>
        </form>
        <div className="sign">
          Already have an account?&nbsp;&nbsp;
          <NavLink to="/login" className="sign-link">
            Log in
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default Register;
